<label class="field-label">
  {{ label }}
  @if (isRequired) {
    <span class="text-red-600" aria-hidden="true">*</span>
  }
</label>
<div class="flex space-x-2 items-center">
  <ng-select
    [items]="countryCodes"
    bindLabel="label"
    bindValue="code"
    [formControl]="countryCodeControl"
    [searchable]="true"
    placeholder=""
    class="min-w-34"
  >
    <ng-template ng-option-tmp let-item="item">
      <span
        class="fi fi-{{ item.name | lowercase }} mr-1"
        aria-hidden="true"
      ></span>
      <span class="font-light">{{ item.label }}</span>
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      <span
        class="fi fi-{{ item.name | lowercase }} mr-1"
        aria-hidden="true"
      ></span>
      {{ item.label }}
    </ng-template>
  </ng-select>

  <!-- Mobile Number Input -->
  <input
    #inputElement
    type="text"
    [formControl]="control"
    [class]="inputClasses"
    [ngClass]="{ 'border-red-500': control.touched && control.invalid }"
  />
</div>

<!-- Optional: Validation Message -->
<!-- <div *ngIf="!isMobileValid()" class="text-red-500 text-sm mt-1">
  Please enter a valid mobile number 509998888.
</div> -->

<div class="fields-error-container">
  <!-- Show custom error messages -->
  @if ((control.touched && control.invalid) || countryCodeControl.touched &&
  countryCodeControl.invalid) { @if (primaryErrorKey && control.hasError(primaryErrorKey)) {
  {{
    validationMessages[primaryErrorKey] ||
      (primaryErrorKey === "required"
        ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
        : "")
  }}
  } }
</div>
